import { useEffect, useState } from 'react';
import { subscriptionStatus } from 'services/api/pay';
import {
  getSubscriptionPayType,
  type SubscriptionPayType,
} from 'hooks/business/pay/usePayTypeState';
import { logPricing } from '../pricingLogger';

export function useSubscriptionChannel(orgId: number) {
  const [workingPaymentChannel, setWorkingPaymentChannel] = useState<SubscriptionPayType>();
  const [subscriptionChannelLoading, setSubscriptionChannelLoading] = useState(true);
  const [subscriptionChannelFailed, setSubscriptionChannelFailed] = useState(false);

  useEffect(() => {
    let active = true;
    setSubscriptionChannelLoading(true);
    setSubscriptionChannelFailed(false);
    subscriptionStatus()
      .then((subscription) => {
        if (!active) return;
        // null 表示没有有效订阅，续订时沿用页面选择的新订阅支付渠道。
        setWorkingPaymentChannel(getSubscriptionPayType(subscription?.paymentChannel));
      })
      .catch((error) => {
        if (!active) return;
        setSubscriptionChannelFailed(true);
        logPricing('subscription_channel_failed', { orgId }, error);
      })
      .finally(() => {
        if (active) setSubscriptionChannelLoading(false);
      });
    return () => {
      active = false;
    };
  }, [orgId]);

  return { workingPaymentChannel, subscriptionChannelLoading, subscriptionChannelFailed };
}
